import {
  Component,
  inject,
  ViewChild,
  ElementRef,
  OnInit,
  ChangeDetectorRef,
} from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { NgForm } from '@angular/forms';
// import { PreventiveApiService } from '@app/services/preventive-api';
import {
  PaginatedResponse,
  RecursiveInterface,
} from '@app/services/base-authenticated.service';
import {
  DocumentTypeOptions,
  PreventiveInterface,
  PensionFundOptions,
  StyleOptions,
} from '@app/interface/preventive';
import { MatTableDataSource } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { CompanyApi } from '@app/services/company-api';
import { CompanyInterface } from '@app/interface/company';
import { Observable } from 'rxjs';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
// import {AsyncPipe} from '@angular/common';
import { map, startWith } from 'rxjs/operators';
// import { OnInit } from '@angular/core';
import { CompanyAutocompleteComponent } from '@app/company-autocomplete/company-autocomplete';
import { CurrencyOption } from '@app/interface/currency-options';
import { PaymentMethodOptions } from '@app/interface/payment-method-options';
// import { LayoutComponent } from '@app/layout/layout.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { TextFieldModule } from '@angular/cdk/text-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { IvaCollectabilityOptions } from '@app/interface/iva-collectability-options';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { NewCompanyDialog } from '@app/new-company/new-company.component';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { LanguageOptions } from '@app/interface/language-options';
import { StatusOptions } from '@app/interface/status-options';
import { MatDividerModule } from '@angular/material/divider';
import { ProductServiceInterface } from '@app/interface/product-service';
import { AtecoCodeInterface } from '@app/interface/ateco-code';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ArubaService } from '@app/services/aruba.service';
import { MatStepperModule } from '@angular/material/stepper';
import { SavedproductAutocompleteComponent } from '@app/savedproduct-autocomplete/savedproduct-autocomplete.component';
import { SavedProductInterface } from '@app/interface/savedproduct';
import * as moment from 'moment';
import { format, parseISO, addDays } from 'date-fns';
import { ConfirmInvoiceDialogComponent } from '@app/confirm-invoice-dialog/confirm-invoice-dialog.component';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import { LoadingDialogComponent } from '@app/loading-dialog/loading-dialog.component';
import { forkJoin } from 'rxjs';
import { ProductserviceApiService } from '@app/services/productservice-api.service';
import { AtecoCodeApiService } from '@app/services/ateco-code-api.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {
  TaxWithholdingInterface,
  KindOptions,
  KindCode,
} from '@app/interface/tax-withholding';
import { TaxWithholdingApi } from '@app/services/tax-withholding-api.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { PreventiveApiService } from '@app/services/preventive-api.service';
import { DownloadConfirmationDialogComponent } from '@app/download-confirmation-dialog/download-confirmation-dialog.component';
import { ConfirmPreventiveDialogComponent } from '@app/confirm-invoice-dialog/confirm-preventive-dialog.component';
import {
  SelectPdfStyleDialogComponent,
  SelectPreviewPdfStyleDialogComponent,
} from '@app/select-pdf-style-dialog/select-pdf-style-dialog.component';
import { OrganizationApi } from '@app/services/organization-api.service';
import { BackHeaderComponent } from '@app/back-header/back-header.component';
import { PdfViewerDialogComponent } from '@app/pdf-viewer-dialog/pdf-viewer-dialog.component';
import { InvoiceApi } from '@app/services/invoice-api';
import { ToastService } from '@app/services/toast.service';

@Component({
  selector: 'izy-new-preventive',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatAutocompleteModule,
    // AsyncPipe,
    CompanyAutocompleteComponent,
    // LayoutComponent,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSlideToggleModule,
    MatCardModule,
    MatIconModule,
    MatDividerModule,
    MatTooltipModule,
    MatStepperModule,
    SavedproductAutocompleteComponent,
    // ConfirmPreventiveDialogComponent,
    MatProgressSpinnerModule,
    MatExpansionModule,
    BackHeaderComponent,
    TextFieldModule,
  ],
  providers: [
    PreventiveApiService,
    CompanyApi,
    { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: 'DD/MM/YYYY',
        },
        display: {
          dateInput: 'DD/MM/YYYY',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      },
    },
  ],
  standalone: true,
  templateUrl: './new-preventive.component.html',
  styleUrl: './new-preventive.component.scss',
})
export class NewPreventiveComponent {
  private toast = inject(ToastService);
  @ViewChild('productsList') productsListElement!: ElementRef;
  @ViewChild('companyAutocomplete') companyAutocomplete!: CompanyAutocompleteComponent;

  // dict:
  currencyOptions: CurrencyOption[] = [
    { code: 'USD', name: 'US Dollar' },
    { code: 'EUR', name: 'Euro' },
    { code: 'GBP', name: 'British Pound' },
    { code: 'JPY', name: 'Japanese Yen' },
    { code: 'CAD', name: 'Canadian Dollar' },
    { code: 'AUD', name: 'Australian Dollar' },
    { code: 'CNY', name: 'Chinese Yuan' },
    { code: 'INR', name: 'Indian Rupee' },
  ];

  paymentMethodOptions: PaymentMethodOptions[] = [
    { code: 'MP01', name: 'Contanti' },
    { code: 'MP02', name: 'Assegno' },
    { code: 'MP03', name: 'Assegno circolare' },
    { code: 'MP04', name: 'Contanti presso Tesoreria' },
    { code: 'MP05', name: 'Bonifico' },
    { code: 'MP06', name: 'Vaglia cambiario' },
    { code: 'MP07', name: 'Bollettino bancario' },
    { code: 'MP08', name: 'Carta di credito' },
    { code: 'MP09', name: 'RID' },
    { code: 'MP10', name: 'RID utenze' },
    { code: 'MP11', name: 'RID veloce' },
    { code: 'MP12', name: 'Riba' },
    { code: 'MP13', name: 'MAV' },
    { code: 'MP14', name: 'Quietanza erario stato' },
    { code: 'MP15', name: 'Giroconto su conti di contabilità speciale' },
    { code: 'MP16', name: 'Domiciliazione bancaria' },
    { code: 'MP17', name: 'Domiciliazione postale' },
  ];

  pensionFundOptions: PensionFundOptions[] = [
    {
      code: 'TC01',
      name: 'Cassa nazionale previdenza e assistenza avvocati e procuratori legali',
    },
    { code: 'TC02', name: 'Cassa previdenza dottori commercialisti' },
    { code: 'TC03', name: 'Cassa previdenza e assistenza geometri' },
    {
      code: 'TC04',
      name: 'Cassa nazionale previdenza e assistenza ingegneri e architetti liberi professionisti',
    },
    { code: 'TC05', name: 'Cassa nazionale del notariato' },
    {
      code: 'TC06',
      name: 'Cassa nazionale previdenza e assistenza ragionieri e periti commerciali',
    },
    {
      code: 'TC07',
      name: 'Ente nazionale assistenza agenti e rappresentanti di commercio (ENASARCO)',
    },
    {
      code: 'TC08',
      name: 'Ente nazionale previdenza e assistenza consulenti del lavoro (ENPACL)',
    },
    {
      code: 'TC09',
      name: 'Ente nazionale previdenza e assistenza medici (ENPAM)',
    },
    {
      code: 'TC10',
      name: 'Ente nazionale previdenza e assistenza farmacisti (ENPAF)',
    },
    {
      code: 'TC11',
      name: 'Ente nazionale previdenza e assistenza veterinari (ENPAV)',
    },
    {
      code: 'TC12',
      name: "Ente nazionale previdenza e assistenza impiegati dell'agricoltura (ENPAIA)",
    },
    {
      code: 'TC13',
      name: 'Fondo previdenza impiegati imprese di spedizione e agenzie marittime',
    },
    {
      code: 'TC14',
      name: 'Istituto nazionale previdenza giornalisti italiani (INPGI)',
    },
    {
      code: 'TC15',
      name: 'Opera nazionale assistenza orfani sanitari italiani (ONAOSI)',
    },
    {
      code: 'TC16',
      name: 'Cassa autonoma assistenza integrativa giornalisti italiani (CASAGIT)',
    },
    {
      code: 'TC17',
      name: 'Ente previdenza periti industriali e periti industriali laureati (EPPI)',
    },
    {
      code: 'TC18',
      name: 'Ente previdenza e assistenza pluricategoriale (EPAP)',
    },
    {
      code: 'TC19',
      name: 'Ente nazionale previdenza e assistenza biologi (ENPAB)',
    },
    {
      code: 'TC20',
      name: 'Ente nazionale previdenza e assistenza professione infermieristica (ENPAPI)',
    },
    {
      code: 'TC21',
      name: 'Ente nazionale previdenza e assistenza psicologi (ENPAP)',
    },
    { code: 'TC22', name: 'INPS' },
  ];

  ivaCollectabilityOptions: IvaCollectabilityOptions[] = [
    { code: 'IMMEDIATA', name: 'Immediata' },
    { code: 'DIFFERITA', name: 'Differita' },
    { code: 'SPLIT', name: 'Split payment' },
  ];

  languageOptions: LanguageOptions[] = [
    { code: 'it', name: 'Italiano' },
    { code: 'en', name: 'Inglese' },
    { code: 'fr', name: 'Francese' },
    { code: 'de', name: 'Tedesco' },
    { code: 'es', name: 'Spagnolo' },
  ];

  statusOptions: StatusOptions[] = [
    { code: 'TRASMESSA', name: 'Trasmessa' },
    { code: 'ATTESA', name: 'Atttesa' },
  ];

  documentTypeOptions: DocumentTypeOptions[] = [
    { code: 'TD01', name: 'Fattura' },
    { code: 'TD04', name: 'Nota di credito' },
  ];

  kindOptions: KindOptions[] = [
    { code: 'CASSA', name: 'Cassa' },
    { code: 'RIVALSA', name: 'Rivalsa' },
    { code: 'RITENUTA', name: 'Ritenuta' },
    { code: 'RITENUTA_ACCONTO', name: "Ritenuta d'acconto" },
  ];

  styleOptions: StyleOptions[] = [
    { code: 'Model1', name: 'Semplice' },
    { code: 'Model2', name: 'Moderno' },
    { code: 'Model3', name: 'Raffinato' },
  ];

  // export type KindCode = 'CASSA' | 'RIVALSA' | 'RITENUTA';

  atecoCodes: AtecoCodeInterface[] = [];
  // selectedAtecoCode: number | null = null; // To store the selected ATECO code ID
  taxWithholdings: Partial<TaxWithholdingInterface>[] = [];

  showDelay = new FormControl(700);
  hideDelay = new FormControl(1000);

  // to display
  preventive_gross_amount: number = 0;
  preventive_discount_amount: number = 0;
  preventive_discount: number = 0;
  preventive_total_amount: number = 0;
  preventive_iva_amount: number = 0;
  numero_articoli: number = 0;
  numero_contributi: number = 0;
  preventive_revenue_stamp: number = 0;

  // totals
  gross_amount: number = 0;
  total_amount: number = 0.0;
  iva_amount: number = 0.0;
  discount_amount: number = 0;
  discount: number = 0;

  // these properties to store intermediate calculation results
  preventive_total_amount_with_rivalsa: number = 0;
  total_taxable: number = 0;
  preventive_total_paid_amount_with_acconto: number = 0;
  preventive_total_paid_amount: number = 0;

  // For display purposes
  rivalsa_total: number = 0;
  rivalsa_rate: number = 0;
  cassa_total: number = 0;
  cassa_rate: number = 0;
  ritenuta_acconto_total: number = 0;
  ritenuta_acconto_rate: number = 0;
  ritenuta_total: number = 0;
  ritenuta_rate: number = 0;

  newPreventive: Partial<PreventiveInterface> = {
    invoice_name: '',
    // emission_date: moment().format('YYYY-MM-DD'), // Default: today's date in YYYY-MM-DD
    // payment_date: moment().format('YYYY-MM-DD'), // Default: today's date in YYYY-MM-DD
    emission_date: format(new Date(), 'yyyy-MM-dd'), // Today's date
    payment_date: format(new Date(), 'yyyy-MM-dd'), // Today's date
    progressive_number: 1,
    enumeration: '2025',
    description: '',
    description_internal: '',
    articles_number: 1,
    amount: 0,
    gross_amount: 0,
    iva_percentage: 0, // FIXME: real percentage
    iva_amount: 0,
    discount_amount: 0,
    discount: 0,
    addressee_code: '0000000',
    addressee_name: '',
    is_paid: false, // default to false
    language: 'it',
    currency: 'EUR',
    p_a: false,
    payment_method: 'MP05',
    iban: '',
    status: 'ATTESA',
    revenue_stamp: 0,
    revenue_stamp_for_company: false,
    iva_collectability: 'IMMEDIATA',
    // emitted_after,
    revenge: 0,
    pension_fund: 0,
    taxable_amount: 0,
    withholding_advance_tax: 0,
    withholding_tax: 0,
    pension_fund_type: 'TC22',
    healthcare_invoice: false,
    document_type: 'TD01',
    document_id: '',
    notes: '',

    is_draft: true,
    is_saved_for_preview: false,

    payment_days: 0, // only to compute payment date

    ateco_code_id: 0,

    organization_id: 1,
    company: {
      company_name: '',
      id: 1,
      iva_number: '',
      address: '',
      addressee_code: '',
      c_f: '',
      email_address: '',
    },
    company_id: 0, // to avoid not authorized invoices

    validity_date: format(new Date(), 'yyyy-MM-dd'),
    // accepted_at: format(new Date(), 'yyyy-MM-dd');
    // accepted: boolean;
    preventives_enumeration: '2025',
    preventives_progressive_number: 1,

    style: 'Model1',
  };

  newProductService: Partial<ProductServiceInterface> = {
    id: 1,
    invoice_id: 1,

    name: '',
    quantity: 1,
    units: '',
    gross_amount: 0,
    discount: 0,
    discount_amount: 0,
    amount: 0,
    description: '',
    iva_percentage: 0,
    iva_amount: 0,
    final_amount: 0,
  };

  // new tax withholding object
  newTaxWithholding: Partial<TaxWithholdingInterface> = {
    kind: 'RITENUTA',
    rate_percentage: 0,
    total_percentage: 100,
    rate_amount: 0,
    total_amount: 0,
    details: '',
  };

  constructor(
    private preventiveService: PreventiveApiService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    // private arubaService: ArubaService,
    private organizationService: OrganizationApi,
    private invoiceService: InvoiceApi,
    private dateAdapter: DateAdapter<Date>,
    private cdr: ChangeDetectorRef,
    private productServiceApi: ProductserviceApiService,
    private AtecoCodesApi: AtecoCodeApiService,
    private taxWithholdingApi: TaxWithholdingApi,
  ) {
    this.dateAdapter.setLocale('it-IT');
  }

  isLoading: boolean = false; // Initialize as false by default
  errorMessage: string | null = null;

  myControl = new FormControl('');
  productControl = new FormControl('');
  companySource = new MatTableDataSource<CompanyInterface>([]); // now usng MatTableDataSource

  ngOnInit() {
    // company pre-selection from company table
    this.route.queryParams.subscribe((params) => {
      if (params['companyId']) {
        // If company data is passed via route
        this.newPreventive.company_id = +params['companyId'];
        this.newPreventive.company = {
          id: +params['companyId'],
          company_name: params['companyName'],
        } as CompanyInterface;

        this.showSuccessMessage(
          `Cliente ${params['companyName']} preselezionato`,
        );
      }

      // document type pre-selection
      if (params['documentType']) {
        const documentTypeCode = params['documentType'];
        const foundDocumentType = this.documentTypeOptions.find(
          (option) => option.code === documentTypeCode,
        );

        if (foundDocumentType) {
          this.newPreventive.document_type = foundDocumentType.code;
          // this.showSuccessMessage(
          //   `Tipo documento ${foundDocumentType.name} preselezionato`
          // );
        }
      }
    });

    this.scrollToTop();
    this.loadAtecoCodes();
    this.setNextProgressiveNumber();
    this.cdr.detectChanges();
  }

  private scrollToTop() {
    // window.scrollTo(0, 0);
    // Alternatively, for smoother scrolling:
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  getDocumentTypeName(code: string): string {
    const found = this.documentTypeOptions.find(
      (option) => option.code === code,
    );
    return found ? found.name : 'Documento';
  }

  /* Importi delle card voce e del riepilogo formattati come in new-invoice
     (locale it-IT, sempre due decimali), invece del pipe `currency` di
     Angular: le due pagine devono scrivere le cifre allo stesso modo. */
  formatCardAmount(
    amount: number | undefined,
    currency: string = 'EUR',
  ): string {
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount ?? 0);
  }

  formatValidityDate(): string {
    if (!this.newPreventive.validity_date) return 'n';

    const date =
      typeof this.newPreventive.validity_date === 'string'
        ? new Date(this.newPreventive.validity_date)
        : this.newPreventive.validity_date;

    return format(date, 'dd/MM/yyyy');
  }

  formatEmissionDate(): string {
    if (!this.newPreventive.emission_date) return 'n';

    const date =
      typeof this.newPreventive.emission_date === 'string'
        ? new Date(this.newPreventive.emission_date)
        : this.newPreventive.emission_date;

    return format(date, 'dd/MM/yyyy');
  }

  private formatDateForDatabase(date: Date | string): string {
    if (!date) return '';

    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return format(dateObj, 'yyyy-MM-dd');
  }

  private setNextProgressiveNumber(): void {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    if (organization_id) {
      this.preventiveService
        .getMaxProgressiveNumber(organization_id)
        .subscribe({
          next: (maxProgressive: number) => {
            // Set progressive_number to max + 1, or 1 if no preventives exist
            this.newPreventive.preventives_progressive_number =
              (maxProgressive || 0) + 1;
            console.log(
              `Auto-set progressive number to: ${this.newPreventive.preventives_progressive_number}`,
            );
          },
          error: (err: any) => {
            console.error('Error fetching max progressive number:', err);
            // Fallback to 1 if there's an error
            this.newPreventive.preventives_progressive_number = 1;
            this.showErrorMessage(
              'Errore nel caricamento del numero progressivo. Usando valore predefinito.',
            );
          },
        });
      this.cdr.detectChanges();
    } else {
      // Fallback if no organization ID
      this.newPreventive.preventives_progressive_number = 1;
      this.cdr.detectChanges();
    }
  }

  private loadAtecoCodes() {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.isLoading = true;
    this.errorMessage = null;

    this.AtecoCodesApi.getAllAtecoCodes<AtecoCodeInterface>(
      organization_id,
      {},
    ).subscribe({
      next: (response: RecursiveInterface<AtecoCodeInterface>) => {
        if (response.completed) {
          // Store all ATECO codes in the component property
          this.atecoCodes = response.results;

          // Auto-select first item in the newPreventive object
          if (
            this.atecoCodes.length > 0 &&
            (this.newPreventive.ateco_code_id === undefined ||
              this.newPreventive.ateco_code_id === null ||
              this.newPreventive.ateco_code_id === 0)
          ) {
            this.newPreventive.ateco_code_id = this.atecoCodes[0].id;
          }

          console.log('All ateco codes loaded', this.atecoCodes.length);
          console.log(
            'Selected ATECO code ID:',
            this.newPreventive.ateco_code_id,
          );
        } else {
          // Optional: Show loading progress
          console.log(
            `Loaded ${response.results.length} saved ateco codes so far...`,
          );
          this.atecoCodes = response.results;
        }
        this.isLoading = false;
      },
      error: (err: any) => {
        this.isLoading = false;
        console.error('Error loading ateco codes:', err);
        this.showErrorMessage('Errore nel caricamento dei codici ATECO.');
      },
    });
  }

  onAtecoCodeChange(event: any): void {
    // The value is now automatically bound to newPreventive.ateco_code_id
    // You can still perform additional logic here if needed
    const selectedAteco = this.atecoCodes.find(
      (code) => code.id === event.value,
    );

    // You can also update other properties if needed
    // For example, if you want to store the full ATECO object:
    // this.newPreventive.ateco_code = selectedAteco;
  }

  onRevenueStampChange(value: any) {
    this.newPreventive.revenue_stamp = value;
    this.preventive_revenue_stamp = value;

    // Trigger full recalculation
    this.calculateAllTaxWithholdings();
  }

  onRevenueStampOptionChange(option: 'none' | 'customer' | 'me') {
    this.revenueStampOption = option;

    // Update the actual revenue stamp values based on selection
    if (option === 'customer') {
      this.newPreventive.revenue_stamp = 2;
      this.preventive_revenue_stamp = 2;
      this.newPreventive.revenue_stamp_for_company = true;
    } else if (option === 'me') {
      this.newPreventive.revenue_stamp = 0; // FIXME: proper revenue_stamp if on me
      this.preventive_revenue_stamp = 0;
      this.newPreventive.revenue_stamp_for_company = false;
      // When it's on you, the stamp exists but doesn't get added to customer total
    } else {
      this.newPreventive.revenue_stamp = 0;
      this.preventive_revenue_stamp = 0;
      this.newPreventive.revenue_stamp_for_company = false;
    }

    // Trigger full recalculation
    this.calculateAllTaxWithholdings();
  }

  onRevenueStampCustomerChange(event: MatSlideToggleChange) {
    if (event.checked) {
      this.revenueStampOption = 'customer';
      this.onRevenueStampOptionChange('customer');
    } else if (this.revenueStampOption === 'customer') {
      this.revenueStampOption = 'none';
      this.onRevenueStampOptionChange('none');
    }
  }

  onRevenueStampMeChange(event: MatSlideToggleChange) {
    if (event.checked) {
      this.revenueStampOption = 'me';
      this.onRevenueStampOptionChange('me');
    } else if (this.revenueStampOption === 'me') {
      this.revenueStampOption = 'none';
      this.onRevenueStampOptionChange('none');
    }
  }

  // methods for tax withholdings
  calculateTaxWithholdingTotal(): void {
    // You can add calculation logic here based on your business rules
    const rate_percentage = this.newTaxWithholding.rate_percentage || 0;
    const total_percentage = this.newTaxWithholding.total_percentage || 0;

    this.newTaxWithholding.rate_percentage = this.roundToTwo(rate_percentage);

    // compute total amount
    this.newTaxWithholding.rate_amount =
      (rate_percentage / 100) *
      (this.preventive_total_amount * (total_percentage / 100));
  }

  getKindDisplayName(kind: string | undefined): string {
    if (!kind) return 'voce';

    const kindMap: { [key: string]: string } = {
      CASSA: 'cassa',
      RIVALSA: 'rivalsa',
      RITENUTA: 'ritenuta',
      RITENUTA_ACCONTO: "ritenuta d'acconto",
    };
    return kindMap[kind] || 'voce';
  }

  isKindAlreadyUsed(kind: string | undefined): boolean {
    if (!kind) return false;
    return this.taxWithholdings.some(
      (withholding) => withholding.kind === kind,
    );
  }

  getAvailableKinds(): KindOptions[] {
    return this.kindOptions.filter(
      (kind) => !this.isKindAlreadyUsed(kind.code),
    );
  }

  // this method to set the first available kind
  setFirstAvailableKind(): void {
    const availableKinds = this.getAvailableKinds();
    if (availableKinds.length > 0) {
      this.newTaxWithholding.kind = availableKinds[0].code;
    }
  }

  addNewTaxWithholding(): void {
    this.calculateTaxWithholdingTotal();

    if (this.newTaxWithholding.total_percentage !== undefined) {
      // Check if a withholding of this kind already exists
      const existingKind = this.taxWithholdings.find(
        (withholding) => withholding.kind === this.newTaxWithholding.kind,
      );

      if (existingKind) {
        this.showErrorMessage(
          `È già presente una ${this.getKindDisplayName(
            this.newTaxWithholding.kind,
          )}. Puoi averne solo una per tipo.`,
        );
        return;
      }

      // Add the current tax withholding to the array
      this.taxWithholdings.push({ ...this.newTaxWithholding });

      this.numero_contributi += 1;

      // Recalculate all withholdings in the correct order INCLUDING revenue stamp
      this.calculateAllTaxWithholdings();

      this.showSuccessMessage(
        `${this.getKindDisplayName(this.newTaxWithholding.kind)} aggiunta`,
      );

      // Reset the form for new entry
      this.newTaxWithholding = {
        kind: 'CASSA',
        rate_percentage: 0,
        total_percentage: 100,
        details: '',
        rate_amount: 0,
        total_amount: 0,
      };
    } else {
      this.showErrorMessage('Inserisci i dati');
    }
  }

  removeTaxWithholding(index: number): void {
    const removedKind = this.taxWithholdings[index].kind;

    // Remove from array
    this.taxWithholdings.splice(index, 1);

    this.numero_contributi -= 1;

    // Recalculate everything INCLUDING revenue stamp
    this.calculateAllTaxWithholdings();

    this.showSuccessMessage(`${this.getKindDisplayName(removedKind)} rimossa.`);

    // If the removed kind was selected in the form, reset the form
    if (this.newTaxWithholding.kind === removedKind) {
      this.newTaxWithholding = {
        kind: 'CASSA',
        rate_percentage: 0,
        total_percentage: 100,
        details: '',
        rate_amount: 0,
        total_amount: 0,
      };
    }
  }

  calculatePaymentDate(
    emissionDate: string | undefined | null,
    days: number,
  ): string {
    if (!emissionDate) {
      emissionDate = format(new Date(), 'yyyy-MM-dd');
    }
    const date = parseISO(emissionDate);
    const paymentDate = addDays(date, days);
    return format(paymentDate, 'yyyy-MM-dd');
  }

  async addNewElement(form?: NgForm, onlyForPreview: boolean = false) {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    let savedDialogResult: boolean = true;

    // akss the user for confirmation
    if (onlyForPreview === false) {
      const dialogRef = this.dialog.open(ConfirmPreventiveDialogComponent);
      const result = await dialogRef.afterClosed().toPromise();

      if (!result) {
        // User cancelled the dialog
        return;
      }
    } else {
      const savedDialogResult = true;
    }

    // only preview mode
    if (onlyForPreview === true) {
      this.newPreventive.is_saved_for_preview = true;
      this.newPreventive.invoice_name = '(Anteprima)';
    } else {
      this.newPreventive.is_saved_for_preview = false;
      this.newPreventive.invoice_name = '';
    }

    if (this.newPreventive.validity_date) {
      this.newPreventive.validity_date = this.formatDateForDatabase(
        this.newPreventive.validity_date,
      );
    }

    // Convert other dates if needed
    if (this.newPreventive.emission_date) {
      this.newPreventive.emission_date = this.formatDateForDatabase(
        this.newPreventive.emission_date,
      );
    }

    if (this.newPreventive.payment_date) {
      this.newPreventive.payment_date = this.formatDateForDatabase(
        this.newPreventive.payment_date,
      );
    }

    this.newPreventive.is_draft = false;

    this.newPreventive.is_preventive = true; // most important thing

    this.newPreventive.addressee_name =
      this.newPreventive.company?.company_name;

    // Set the preventive amount to the accumulated total
    if (this.newPreventive.revenue_stamp_for_company === true) {
      this.newPreventive.gross_amount =
        this.preventive_gross_amount + this.preventive_revenue_stamp;
    } else {
      this.newPreventive.gross_amount = this.preventive_gross_amount;
    }
    this.newPreventive.revenue_stamp = this.preventive_revenue_stamp;
    this.newPreventive.amount = Number(this.preventive_total_paid_amount); // preventive_total_amount
    this.newPreventive.iva_amount = this.preventive_iva_amount;
    this.newPreventive.discount_amount = this.preventive_discount_amount;
    // compute the tax withholdings
    this.newPreventive.revenge = Number(this.rivalsa_total);
    this.newPreventive.revenge_rate = Number(this.rivalsa_rate);
    this.newPreventive.pension_fund = Number(this.cassa_total);
    this.newPreventive.pension_fund_rate = Number(this.cassa_rate);
    this.newPreventive.taxable_amount = Number(this.total_taxable);
    this.newPreventive.withholding_advance_tax = Number(
      this.ritenuta_acconto_total,
    );
    this.newPreventive.withholding_advance_tax_rate = Number(
      this.ritenuta_acconto_rate,
    );
    this.newPreventive.withholding_tax = Number(this.ritenuta_total);
    this.newPreventive.withholding_tax_rate = Number(this.ritenuta_rate);

    const formattedEmissionDate = format(
      new Date(this.newPreventive.emission_date!),
      'yyyy-MM-dd',
    );
    const formattedPaymentDate = format(
      new Date(this.newPreventive.payment_date!),
      'yyyy-MM-dd',
    );

    this.newPreventive.emission_date = formattedEmissionDate;
    this.newPreventive.payment_date = formattedPaymentDate;

    // validate required fields
    console.log(
      !this.newPreventive.organization_id || !this.newPreventive.company?.id,
    );
    console.log(this.newPreventive);

    this.onRevenueStampChange(this.preventive_revenue_stamp);

    // compute payment date
    this.newPreventive.payment_date = this.calculatePaymentDate(
      this.newPreventive.emission_date || format(new Date(), 'yyyy-MM-dd'),
      this.newPreventive.payment_days || 0,
    );

    // console.log('Final:', this.newPreventive); // debugging

    // only preview invoices are also drafts
    if (onlyForPreview === false) {
      this.newPreventive.is_draft = false;
    } else {
      this.newPreventive.is_draft = true;
    }

    // show a loading
    if (savedDialogResult) {
      // User confirmed - show loading dialog
      const loadingDialogRef = this.dialog.open(LoadingDialogComponent, {
        width: '90vw',
        maxWidth: '400px',
        height: '300px',
        disableClose: true, // Prevent closing during loading
      });

      // Combine fake delay with actual API call
      await Promise.all([
        new Promise((resolve) => setTimeout(resolve, 700)), // less than 1-second delay
      ]);

      this.preventiveService
        .createPreventive(organization_id, this.newPreventive)
        .subscribe({
          next: (createdPreventive: PreventiveInterface) => {
            // Now save all product services for this preventive
            const productServices$ =
              this.productServices.length > 0
                ? this.saveProductServicesForPreventive(
                    createdPreventive.id!,
                    organization_id,
                  )
                : new Observable<ProductServiceInterface[]>((observer) => {
                    observer.next([]);
                    observer.complete();
                  });

            // Now save all tax withholdings for this preventive
            const taxWithholdings$ =
              this.taxWithholdings.length > 0
                ? this.saveTaxWithholdingsForPreventive(
                    createdPreventive.id!,
                    organization_id,
                  )
                : new Observable<TaxWithholdingInterface[]>((observer) => {
                    observer.next([]);
                    observer.complete();
                  });

            // Wait for both product services and tax withholdings to complete
            forkJoin([productServices$, taxWithholdings$]).subscribe({
              next: ([savedServices, savedWithholdings]) => {
                console.log(
                  'All product services saved successfully:',
                  savedServices,
                );
                console.log(
                  'All tax withholdings saved successfully:',
                  savedWithholdings,
                );

                // Update local arrays with saved data (with real IDs)
                this.productServices = savedServices.map((service, index) => ({
                  ...this.productServices[index],
                  id: service.id,
                }));

                this.taxWithholdings = savedWithholdings.map(
                  (withholding, index) => ({
                    ...this.taxWithholdings[index],
                    id: withholding.id,
                  }),
                );

                // only preview mode
                if (onlyForPreview === false) {
                  const successMessage = `${createdPreventive.invoice_name} (totale: ${createdPreventive.amount} ${createdPreventive.currency}) creata!`;
                  this.showSuccessMessage(successMessage);

                  this.resetForm(form);

                  // Show download confirmation dialog
                  this.openDownloadConfirmationDialog(createdPreventive);
                } else {
                  this.onViewPdfClick(createdPreventive.id);
                }

                loadingDialogRef.close();

                // only preview mode
                if (onlyForPreview === false) {
                  this.backToTable();
                }
              },
              error: (error) => {
                console.error(
                  'Error saving product services or tax withholdings:',
                  error,
                );
                this.showSuccessMessage(
                  `${createdPreventive.invoice_name} creata, ma errore nel salvataggio delle voci o contributi.`,
                );
                this.resetForm(form);
                loadingDialogRef.close();
              },
            });
          },
          error: (err: any) => {
            console.error('Error creating preventive:', err);
            this.showErrorMessage('Errore durante la creazione. Riprovare.');
          },
        });

      // Close loading dialog
      loadingDialogRef.close();
    }
  }

  // Method to open PDF in dialog - receives blobUrl from service
  openPdfDialog(pdfUrl: string, invoiceId: number): void {
    const dialogRef = this.dialog.open(PdfViewerDialogComponent, {
      width: '90vw',
      maxWidth: '1200px',
      height: '90vh',
      data: {
        pdfUrl: pdfUrl,
        invoiceId: invoiceId,
      },
    });

    // Clean up blob URL when dialog closes
    dialogRef.afterClosed().subscribe(() => {
      window.URL.revokeObjectURL(pdfUrl);
    });
  }

  // Main method to view PDF - calls service and opens dialog
  async showPdf(invoiceId: number): Promise<void> {
    const dialogRef = this.dialog.open(SelectPreviewPdfStyleDialogComponent, {
      width: '90vw',
      maxWidth: '400px',
      height: '465px',
      data: {
        title: 'Vedi anteprima del Preventivo',
        message: 'Seleziona lo stile del PDF che preferisci.',
      },
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      // Added 'async' here
      if (result && result.download) {
        try {
          const blobUrl = await this.preventiveService.showPdfInDialog(
            invoiceId,
            result.style,
          );
          this.openPdfDialog(blobUrl, invoiceId);
        } catch (error) {
          this.showErrorMessage('Errore nel caricamento del PDF.');
          console.error('Error loading PDF:', error);
        }
      }
    });
  }

  // Convenience method for template binding
  onViewPdfClick(invoiceId: number): void {
    this.showPdf(invoiceId);
  }

  openDownloadConfirmationDialog(preventive: PreventiveInterface): void {
    const downloadDialogRef = this.dialog.open(
      DownloadConfirmationDialogComponent,
      {
        width: '90vw',
        maxWidth: '500px',
        data: {
          title: 'Preventivo creato con successo!',
          documentType: 'Il preventivo',
          invoiceId: preventive.id!,
          invoiceName: preventive.invoice_name,
          companyName: preventive.company.company_name,
          text: 'è stato creato correttamente.',
        },
      },
    );

    downloadDialogRef.afterClosed().subscribe((result) => {
      if (result && result.download) {
        this.downloadPreventivePdf(preventive.id!);
      }
    });
  }

  saveTaxWithholdingsForPreventive(
    preventiveId: number,
    organizationId: number,
  ): Observable<TaxWithholdingInterface[]> {
    if (this.taxWithholdings.length === 0) {
      return new Observable<TaxWithholdingInterface[]>((observer) => {
        observer.next([]);
        observer.complete();
      });
    }

    const saveObservables: Observable<TaxWithholdingInterface>[] =
      this.taxWithholdings.map((withholding) => {
        const withholdingWithPreventiveId: Partial<TaxWithholdingInterface> = {
          ...withholding,
          invoice_id: preventiveId,
        };

        return this.taxWithholdingApi.createTaxWithholding(
          preventiveId,
          organizationId,
          withholdingWithPreventiveId,
        );
      });

    return forkJoin(saveObservables);
  }

  // async saveDraftElement(form?: NgForm) {
  //   const organization_id = Number(
  //     this.route.snapshot.paramMap.get('organizationId')
  //   );

  //   this.newPreventive.is_draft = true;

  //   this.newPreventive.addressee_name =
  //     this.newPreventive.company?.company_name;

  //   // Set the preventive amount to the accumulated total - use the same calculation as addNewElement
  //   if (this.newPreventive.revenue_stamp_for_company === true) {
  //     this.newPreventive.gross_amount =
  //       this.preventive_gross_amount + this.preventive_revenue_stamp;
  //   } else {
  //     this.newPreventive.gross_amount = this.preventive_gross_amount;
  //   }
  //   this.newPreventive.revenue_stamp = this.preventive_revenue_stamp;
  //   this.newPreventive.amount = Number(this.preventive_total_paid_amount); // Use the same final amount calculation
  //   this.newPreventive.iva_amount = this.preventive_iva_amount;
  //   this.newPreventive.discount_amount = this.preventive_discount_amount;

  //   // Include the same tax withholding calculations as addNewElement
  //   this.newPreventive.revenge = Number(this.rivalsa_total);
  //   this.newPreventive.pension_fund = Number(this.cassa_total);
  //   this.newPreventive.taxable_amount = Number(this.total_taxable);
  //   this.newPreventive.withholding_advance_tax = Number(
  //     this.ritenuta_acconto_total
  //   );
  //   this.newPreventive.withholding_tax = Number(this.ritenuta_total);

  //   const formattedEmissionDate = format(
  //     new Date(this.newPreventive.emission_date!),
  //     'yyyy-MM-dd'
  //   );
  //   const formattedPaymentDate = format(
  //     new Date(this.newPreventive.payment_date!),
  //     'yyyy-MM-dd'
  //   );

  //   this.newPreventive.emission_date = formattedEmissionDate;
  //   this.newPreventive.payment_date = formattedPaymentDate;

  //   // validate required fields
  //   console.log(
  //     !this.newPreventive.organization_id || !this.newPreventive.company?.id
  //   );
  //   console.log(this.newPreventive);

  //   this.onRevenueStampChange(this.preventive_revenue_stamp);

  //   // compute payment date
  //   this.newPreventive.payment_date = this.calculatePaymentDate(
  //     this.newPreventive.emission_date || format(new Date(), 'yyyy-MM-dd'),
  //     this.newPreventive.payment_days || 0
  //   );

  //   console.log('Final Draft:', this.newPreventive);

  //   // Show loading dialog for draft as well
  //   const loadingDialogRef = this.dialog.open(LoadingDialogComponent, {
  //     width: '90vw',
  //     maxWidth: '400px',
  //     height: '300px',
  //     disableClose: true,
  //   });

  //   // Combine fake delay with actual API call
  //   await Promise.all([new Promise((resolve) => setTimeout(resolve, 700))]);

  //   this.preventiveService
  //     .createPreventive(organization_id, this.newPreventive)
  //     .subscribe({
  //       next: (createdPreventive: PreventiveInterface) => {
  //         // Now save all product services for this preventive (same as addNewElement)
  //         const productServices$ =
  //           this.productServices.length > 0
  //             ? this.saveProductServicesForPreventive(
  //                 createdPreventive.id!,
  //                 organization_id
  //               )
  //             : new Observable<ProductServiceInterface[]>((observer) => {
  //                 observer.next([]);
  //                 observer.complete();
  //               });

  //         // Now save all tax withholdings for this preventive (same as addNewElement)
  //         const taxWithholdings$ =
  //           this.taxWithholdings.length > 0
  //             ? this.saveTaxWithholdingsForPreventive(
  //                 createdPreventive.id!,
  //                 organization_id
  //               )
  //             : new Observable<TaxWithholdingInterface[]>((observer) => {
  //                 observer.next([]);
  //                 observer.complete();
  //               });

  //         // Wait for both product services and tax withholdings to complete
  //         forkJoin([productServices$, taxWithholdings$]).subscribe({
  //           next: ([savedServices, savedWithholdings]) => {
  //             console.log(
  //               'All product services saved successfully for draft:',
  //               savedServices
  //             );
  //             console.log(
  //               'All tax withholdings saved successfully for draft:',
  //               savedWithholdings
  //             );

  //             // Update local arrays with saved data (with real IDs)
  //             this.productServices = savedServices.map((service, index) => ({
  //               ...this.productServices[index],
  //               id: service.id,
  //             }));

  //             this.taxWithholdings = savedWithholdings.map(
  //               (withholding, index) => ({
  //                 ...this.taxWithholdings[index],
  //                 id: withholding.id,
  //               })
  //             );

  //             const successMessage = `${createdPreventive.invoice_name} salvata come bozza!`;
  //             this.showSuccessMessage(successMessage);

  //             this.resetForm(form);
  //             loadingDialogRef.close();
  //           },
  //           error: (error) => {
  //             console.error(
  //               'Error saving product services or tax withholdings for draft:',
  //               error
  //             );
  //             this.showSuccessMessage(
  //               `${createdPreventive.invoice_name} salvata come bozza, ma errore nel salvataggio delle voci o contributi.`
  //             );
  //             this.resetForm(form);
  //             loadingDialogRef.close();
  //           },
  //         });
  //       },
  //       error: (err: any) => {
  //         console.error('Error creating draft preventive:', err);
  //         this.showErrorMessage(
  //           'Errore durante il salvataggio della bozza. Riprovare.'
  //         );
  //         loadingDialogRef.close();
  //       },
  //     });
  // }

  calculateTotalTaxWithholdings(): number {
    return this.taxWithholdings.reduce((total_percentage, withholding) => {
      return total_percentage + (withholding.total_percentage || 0);
    }, 0);
  }

  // Main method to calculate all tax withholdings in the correct order
  calculateAllTaxWithholdings(): void {
    let currentAmount = this.preventive_total_amount; // This is now WITHOUT IVA

    // Step 0: BEFORE add revenue stamp (only if charged to customer)
    if (this.revenueStampOption === 'customer') {
      currentAmount += Number(this.preventive_revenue_stamp);
    }

    // Step 1: Calculate 'rivalsa' withholdings on the original total (without IVA)
    const rivalsaAmount = this.calculateTaxWithholdingsByKind('RIVALSA');
    const preventive_total_amount_with_rivalsa = currentAmount + rivalsaAmount;

    // Step 2: Calculate 'cassa' withholdings on the amount with rivalsa (without IVA)
    const cassaAmount = this.calculateTaxWithholdingsByKind('CASSA');
    const total_taxable = preventive_total_amount_with_rivalsa + cassaAmount;

    // Step 3: NOW calculate IVA on the total_taxable
    const totalIvaAmount = this.calculateTotalIvaAmount(total_taxable);
    const total_with_iva = total_taxable + totalIvaAmount;

    // Step 4: Calculate 'ritenuta' withholdings on the total_with_iva
    const ritenutaAccontoAmount =
      this.calculateTaxWithholdingsByKind('RITENUTA_ACCONTO');
    const preventive_total_paid_amount_with_acconto =
      total_with_iva - ritenutaAccontoAmount;

    // Step 5: Calculate 'ritenuta acconto' withholdings on the total_with_iva
    const ritenutaAmount = this.calculateTaxWithholdingsByKind('RITENUTA');
    let preventive_total_paid_amount =
      preventive_total_paid_amount_with_acconto - ritenutaAmount;

    // Step 6: FINALLY add revenue stamp (only if charged to customer)
    // if (this.revenueStampOption === 'customer') {
    //   preventive_total_paid_amount += Number(this.preventive_revenue_stamp);
    // }

    // Update the final amounts
    this.preventive_total_amount_with_rivalsa = this.roundToTwo(
      preventive_total_amount_with_rivalsa,
    );
    this.total_taxable = this.roundToTwo(total_taxable);
    this.preventive_iva_amount = this.roundToTwo(totalIvaAmount); // Store the total IVA
    this.preventive_total_paid_amount_with_acconto = this.roundToTwo(
      preventive_total_paid_amount_with_acconto,
    );
    this.preventive_total_paid_amount = this.roundToTwo(
      preventive_total_paid_amount,
    );

    // Store intermediate values for display
    this.rivalsa_total = this.roundToTwo(rivalsaAmount);
    this.cassa_total = this.roundToTwo(cassaAmount);
    this.ritenuta_acconto_total = this.roundToTwo(ritenutaAccontoAmount);
    this.ritenuta_total = this.roundToTwo(ritenutaAmount);
  }

  // Enhanced method to calculate tax withholdings by kind with percentage application
  calculateTaxWithholdingsByKind(kind: KindCode): number {
    return this.taxWithholdings
      .filter((withholding) => withholding.kind === kind)
      .reduce((total, withholding) => {
        let baseAmount = 0;

        // Determine the base amount based on the kind and calculation order
        if (kind === 'RIVALSA') {
          baseAmount =
            this.preventive_total_amount + this.preventive_revenue_stamp;
          this.newPreventive.pension_fund_type = 'TC22'; // INPS
        } else if (kind === 'CASSA') {
          baseAmount =
            this.preventive_total_amount_with_rivalsa ||
            this.preventive_total_amount;
        } else if (kind === 'RITENUTA_ACCONTO') {
          baseAmount =
            this.preventive_total_amount_with_rivalsa ||
            this.preventive_total_amount;
        } else if (kind === 'RITENUTA') {
          baseAmount =
            this.preventive_total_amount || this.preventive_total_amount; // FIXME: Sthis.preventive_revenue_stamp ??
        }

        const percentage = withholding.total_percentage || 0;
        const rate = withholding.rate_percentage || 0;

        if (kind === 'RIVALSA') {
          this.rivalsa_rate = rate;
        } else if (kind === 'CASSA') {
          this.cassa_rate = rate;
        } else if (kind === 'RITENUTA_ACCONTO') {
          this.ritenuta_acconto_rate = rate;
        } else if (kind === 'RITENUTA') {
          this.ritenuta_rate = rate;
        }

        // Calculate the amount for this withholding
        const withholdingAmount =
          baseAmount * (percentage / 100) * (rate / 100);

        // Update the withholding object with the calculated amount
        withholding.rate_amount = this.roundToTwo(withholdingAmount);

        return total + withholdingAmount;
      }, 0);
  }

  // Individual methods for each type (optional, for convenience)
  // calculateTotalRivalsa(): number {
  //   return this.calculateTaxWithholdingsByKind('RIVALSA');
  // }

  // calculateTotalCassa(): number {
  //   return this.calculateTaxWithholdingsByKind('CASSA');
  // }

  // calculateTotalRitenute(): number {
  //   return this.calculateTaxWithholdingsByKind('RITENUTA');
  // }

  // Check if any withholdings of a specific kind exist
  hasTaxWithholdingsOfKind(kind: KindCode): boolean {
    return this.taxWithholdings.some(
      (withholding) => withholding.kind === kind,
    );
  }

  // "list"
  productServices: Partial<ProductServiceInterface>[] = [];

  // handy functions
  calculateFinalAmount(): void {
    // Set defaults if undefined
    const gross = this.newProductService.gross_amount || 0;
    const quantity = this.newProductService.quantity || 1;
    const discount = (this.newProductService.discount || 0) / 100;

    // Calculate components WITHOUT IVA for now
    const grossTotal = gross * quantity;
    const discountAmount = grossTotal * discount;
    const taxableAmount = grossTotal - discountAmount;

    // Store the taxable amount (without IVA)
    this.newProductService.amount = this.roundToTwo(taxableAmount);
    this.newProductService.final_amount = this.roundToTwo(taxableAmount); // This will be updated later with IVA

    // Store IVA percentage but don't calculate the amount yet
    // this.newProductService.iva_amount will be calculated later
  }

  // Helper function for proper rounding
  private roundToTwo(num: number): number {
    return Math.round((num + Number.EPSILON) * 100) / 100;
  }

  calculateTotalIvaAmount(taxableBase: number): number {
    // Calculate weighted average IVA percentage from all products
    let totalTaxable = 0;
    let totalIvaWeighted = 0;

    this.productServices.forEach((service) => {
      const serviceTaxable = service.amount || 0;
      const serviceIvaPercentage = service.iva_percentage || 0;

      totalTaxable += serviceTaxable;
      totalIvaWeighted += serviceTaxable * (serviceIvaPercentage / 100);
    });

    if (totalTaxable === 0) return 0;

    // Calculate the effective IVA percentage
    const effectiveIvaPercentage = totalIvaWeighted / totalTaxable;

    // Apply this percentage to the taxable base
    return taxableBase * effectiveIvaPercentage;
  }

  calculateFinalAmountWithTaxWithholding(): void {
    const TaxWithholdingsAmount = this.taxWithholdings.reduce(
      (total, withholding) => total + (withholding.rate_amount || 0),
      0,
    );

    this.preventive_total_amount =
      this.preventive_total_amount + TaxWithholdingsAmount;
  }

  addNewProductService(form?: NgForm) {
    this.calculateFinalAmount();

    this.gross_amount +=
      Number(this.newProductService.gross_amount) *
      Number(this.newProductService.quantity);
    this.newProductService.discount_amount =
      ((this.newProductService.discount_amount || 0) +
        (this.newProductService.gross_amount || 0) *
          (Number(this.newProductService.discount) / 100)) *
      Number(this.newProductService.quantity);

    if (this.newProductService.final_amount) {
      // Add the current product/service to the array
      this.productServices.push({ ...this.newProductService });

      // Update totals WITHOUT IVA
      this.total_amount += Number(this.newProductService.amount); // Use amount (without IVA) instead of final_amount
      this.discount_amount += this.roundToTwo(
        Number(this.newProductService.discount_amount),
      );
      this.discount += Number(this.newProductService.discount);
      this.numero_articoli += 1;

      // copy them (without IVA for now)
      this.preventive_gross_amount = this.roundToTwo(this.gross_amount);
      this.preventive_total_amount = this.roundToTwo(this.total_amount); // This is now WITHOUT IVA
      this.preventive_discount_amount = this.roundToTwo(this.discount_amount);
      this.preventive_discount = this.roundToTwo(this.discount);

      // Reset IVA amount - it will be calculated later
      this.preventive_iva_amount = 0;

      // Don't add revenue stamp here anymore
      // this.onRevenueStampChange(this.preventive_revenue_stamp);

      // reset the form for new entry
      if (form) {
        form.resetForm();
        this.newProductService = {
          invoice_id: 1,
          name: '',
          quantity: 1,
          units: '',
          gross_amount: 0,
          discount: 0,
          discount_amount: 0,
          amount: 0,
          description: '',
          iva_percentage: 0,
          iva_amount: 0,
          final_amount: 0,
        };
      }

      console.log('listona:', this.productServices);

      // Recalculate everything with the new order
      this.calculateAllTaxWithholdings();

      this.showSuccessMessage('Prodotto o servizio aggiunto');
    } else {
      this.showErrorMessage('Inserisci il totale');
    }
  }

  // method for individual creation
  saveProductServicesForPreventive(
    preventiveId: number,
    organizationId: number,
  ): Observable<ProductServiceInterface[]> {
    if (this.productServices.length === 0) {
      return new Observable<ProductServiceInterface[]>((observer) => {
        observer.next([]);
        observer.complete();
      });
    }

    // Create an array of observables for each product service
    const saveObservables: Observable<ProductServiceInterface>[] =
      this.productServices.map((service) => {
        const serviceWithPreventiveId: Partial<ProductServiceInterface> = {
          ...service,
          invoice_id: preventiveId,
        };

        console.log('serviceWithPreventiveId', serviceWithPreventiveId);

        return this.productServiceApi.createProductService(
          preventiveId,
          organizationId,
          serviceWithPreventiveId,
        );
      });

    // Use forkJoin to wait for all requests to complete and return an array
    return forkJoin(saveObservables);
  }

  scrollToProductList(): void {
    if (this.productsListElement) {
      this.productsListElement.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }
  }

  clearCompanySelection(): void {
    this.myControl.setValue('');
    this.onCompanySelected(null);
  }

  // validate discount
  // validateDiscount() {
  //   if (this.newProductService.discount > 100) {
  //     this.newProductService.discount = 100;
  //   } else if (this.newProductService.discount < 0) {
  //     this.newProductService.discount = 0;
  //   }
  //   this.calculateFinalAmount();
  // }

  removeProductService(index: number) {
    // Subtract the amount before removing
    this.gross_amount -=
      Number(this.productServices[index].gross_amount) *
      Number(this.productServices[index].quantity);
    this.total_amount -= Number(this.productServices[index].final_amount);
    console.log(
      'amountssss:',
      Number(this.productServices[index].discount_amount),
      this.discount_amount,
    );
    this.discount_amount -= Number(this.productServices[index].discount_amount);
    console.log(
      'amountssss 2:',
      Number(this.productServices[index].discount_amount),
      this.discount_amount,
    );
    this.iva_amount -= Number(this.productServices[index].iva_amount);
    this.numero_articoli -= 1;

    this.preventive_gross_amount = this.gross_amount;
    this.preventive_total_amount = this.total_amount;
    this.preventive_discount_amount = this.discount_amount;
    this.preventive_iva_amount = this.iva_amount;

    this.onRevenueStampChange(this.preventive_revenue_stamp);

    // Remove from array
    this.productServices.splice(index, 1);

    this.calculateAllTaxWithholdings();

    this.showSuccessMessage('Voce rimossa.');
  }

  onCompanySelected(company: CompanyInterface | null): void {
    if (company) {
      this.newPreventive.company_id = company.id;
      this.newPreventive.company = company;
      // invoice addressee code (SDI)
      this.newPreventive.addressee_code = company.addressee_code;

      this.showSuccessMessage(
        `Cliente ${this.newPreventive.company.company_name} selezionato.`,
      );
    } else {
      // Clear the company selection
      this.newPreventive.company_id = undefined;
      this.newPreventive.company = {
        company_name: '',
        id: 0,
        iva_number: '',
        address: '',
        addressee_code: '',
        c_f: '',
        email_address: '',
      };
    }
    console.log('Selected Company:', this.newPreventive); // debugging
  }

  checkPreventive(): void {
    console.log('Selected Company ID:', this.newPreventive.company);
    // You might also want to store the full company object if needed
    console.log('Check company:', this.newPreventive); // debugging
  }

  onSavedProductSelected(savedProduct: SavedProductInterface): void {
    // this.newPreventive.company_id = savedProduct.id;
    console.log('Selected Product ID:', savedProduct.id);
    // You might also want to store the full company object if needed
    this.newProductService.name = savedProduct.name;
    this.newProductService.units = savedProduct.units;
    this.newProductService.gross_amount = savedProduct.unit_price;
    this.newProductService.description = savedProduct.description;
    this.newProductService.iva_percentage = savedProduct.iva_percentage;
    console.log('Selected Product:', savedProduct); // debugging
  }

  // onCompanyNameSelected(companyName: string) {
  //   const selectedCompany = this.companySource.data.find(
  //     // companySource?
  //     (company: { company_name: string }) =>
  //       company.company_name === companyName
  //   );

  //   if (selectedCompany) {
  //     this.newPreventive.company_id = selectedCompany.id;
  //     console.log('Selected company ID:', selectedCompany.id);
  //   }
  // }

  onPaToggleChange(event: MatSlideToggleChange) {
    if (event.checked) {
      // If "Pubblica Amministrazione" is checked
      this.newPreventive.iva_collectability = 'SPLIT';
    } else {
      // If unchecked
      this.newPreventive.iva_collectability = 'IMMEDIATA';
    }
  }

  onHealthcareToggleChange(event: MatSlideToggleChange) {
    if (event.checked) {
      // If "healthcare_invoice" is checked
      this.newPreventive.healthcare_invoice = true;
    } else {
      // If unchecked
      this.newPreventive.healthcare_invoice = false;
    }
  }

  revenueStampOption: 'none' | 'customer' | 'me' = 'none';

  // private updateTotalWithRevenueStamp(): void {
  //   // Start with the base total amount
  //   this.preventive_total_amount = Number(this.total_amount);

  //   // Only add revenue stamp if it's charged to the customer
  //   if (this.revenueStampOption === 'customer') {
  //     this.preventive_total_amount += Number(this.preventive_revenue_stamp);
  //   }

  //   // If revenue stamp is on you (the business), it doesn't affect the preventive total
  //   // The cost is absorbed by the business, so the customer doesn't see it
  // }

  navigateToNewCompany() {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    // console.log(org_id);
    this.router.navigate([`/${org_id}/new_company`]);
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(NewCompanyDialog, {
      width: '7000px',
      data: {},
    });

    // Quando il dialog si chiude, se è stata creata una company la carichiamo
    // nell'autocomplete e la pre-selezioniamo automaticamente
    dialogRef.afterClosed().subscribe((createdCompany) => {
      if (createdCompany && this.companyAutocomplete) {
        this.companyAutocomplete.reload(createdCompany);
      }
    });
  }

  // upload to Aruba
  generateAndUpload(preventiveId: number) {
    // this.arubaService.generateAndUploadPreventive(preventiveId).subscribe({
    //   next: (response: any) => {
    //     console.log('Success!', response);
    //     alert('Preventive processed and uploaded!');
    //     this.showSuccessMessage('Aruba works!');
    //   },
    //   error: (err: any) => {
    //     console.error('Error:', err);
    //     alert('Operation failed.');
    //   },
    // });
  }

  downloadPreventivePdf(invoiceId: number): void {
    // Open the dialog first
    const dialogRef = this.dialog.open(SelectPdfStyleDialogComponent, {
      // un 500px secco sul telefono sborderebbe dallo schermo
      width: '90vw',
      maxWidth: '500px',
      data: {
        title: 'Scarica PDF Preventivo',
        message: 'Seleziona lo stile del PDF che preferisci.',
      },
    });

    // Handle dialog result
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.download) {
        try {
          // Pass the selected style to your service
          this.preventiveService.downloadPreventivePdf(invoiceId, result.style);
          this.showSuccessMessage(
            `La fattura è stata scaricata sul dispositivo con successo!`,
          );
        } catch (error) {
          this.showErrorMessage('Failed to download PDF');
        }
      }
    });
  }

  backToTable(): void {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/preventives_table`]);
  }

  private resetForm(form?: NgForm) {
    if (form) {
      form.resetForm();
    }
    ((this.newPreventive = {
      invoice_name: '',
      amount: 0,
      organization_id: 1,
      // company: this.companies[0], // {company_name:'default', id:1}
      company_id: 1,
    }),
      console.log('reset'));
  }

  private showSuccessMessage(message: string): void {
    this.toast.success(message);
  }

  private showErrorMessage(message: string): void {
    this.toast.error(message);
  }
}
